import { render, staticRenderFns } from "./GMainHeading.vue?vue&type=template&id=f85eb0a0&scoped=true&"
import script from "./GMainHeading.vue?vue&type=script&lang=ts&"
export * from "./GMainHeading.vue?vue&type=script&lang=ts&"
import style0 from "./GMainHeading.vue?vue&type=style&index=0&id=f85eb0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85eb0a0",
  null
  
)

export default component.exports